import { ParametricEngine } from '../ParametricEngine';
import { FamilySchema } from './FamilySchema';
import { familyManager } from '../FamilyManager';

export class FamilyLoader {
    constructor(private engine: ParametricEngine) { }

    async loadFamily(jsonConfig: FamilySchema): Promise<void> {
        console.log(`Loading Family: ${jsonConfig.name} (${jsonConfig.version})`);

        // Register with FamilyManager to enable instantiation
        familyManager.registerSchema(jsonConfig);

        return Promise.resolve();
    }

    parseFromString(jsonString: string): FamilySchema | null {
        try {
            return JSON.parse(jsonString) as FamilySchema;
        } catch (e) {
            console.error('Failed to parse Family JSON', e);
            return null;
        }
    }
}
